module.exports = __webpack_public_path__ + "img/BOR_map.1db25abc.jpg";